import React from 'react'
import { PathwayDetailPageQuery } from './PathwayDetailPage.codegen'

export type PathwayDetailPageContextType = {
  pathway?: PathwayDetailPageQuery['pathway'] | null
  refetch: () => Promise<void>
}
export const PathwayDetailPageContext =
  React.createContext<PathwayDetailPageContextType>(
    null as unknown as PathwayDetailPageContextType
  )
